// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1hymz","col":"styles_col__3G7HU"};